import { useSourcingExternalStore } from 'modules/sourcing-external/stores';
import { useShallow } from 'zustand/react/shallow';
import { getSourcingExternalHeaderBreadcrumbs } from 'modules/sourcing-external/utils';
import { SourcingSharedCustomizeMessageStep } from 'modules/sourcing-shared/shared-steps/SourcingSharedCustomizeMessageStep';
import { Channels } from 'generated-graphql/types';
import { useRecoilValue } from 'recoil';
import { integrationAtom } from 'services/integration/atom';
import { usePortalUrl } from 'modules/portal/hooks/usePortalUrl';

export const SourcingExternalCustomizeMessageStep = () => {
  const {
    candidateBatch,
    selectedRows,
    editedOpeningMessage,
    customizeMessageFormData,
    applicationFormData,
    jobInformationFormData,
    defaultStartingTemplatedMessage,
    isDefaultStartingTemplatedMessageLoading,
    channelFormData,
    onCustomizeMessageBack,
    onCustomizeMessageNext,
    onCustomizeMessageInviteSubmit,
    setStep
  } = useSourcingExternalStore(
    useShallow((state) => ({
      candidateBatch: state.candidateBatch,
      selectedRows: state.selectedRows,
      editedOpeningMessage: state.editedOpeningMessage,
      customizeMessageFormData: state.customizeMessageFormData,
      applicationFormData: state.applicationFormData,
      jobInformationFormData: state.jobInformationFormData,
      isDefaultStartingTemplatedMessageLoading:
        state.isDefaultStartingTemplatedMessageLoading,
      defaultStartingTemplatedMessage: state.defaultStartingTemplatedMessage,
      channelFormData: state.channelFormData,
      onCustomizeMessageBack: state.onCustomizeMessageBack,
      onCustomizeMessageNext: state.onCustomizeMessageNext,
      onCustomizeMessageInviteSubmit: state.onCustomizeMessageInviteSubmit,
      setStep: state.setStep
    }))
  );

  const integrationCredentials = useRecoilValue(integrationAtom);
  const { portalUrl } = usePortalUrl({
    candidateBatchId: candidateBatch?.id ?? ''
  });

  const handleCustomizeMessageBack = () => {
    onCustomizeMessageBack({
      integrationCredentials,
      portalUrl
    });
  };

  return (
    <SourcingSharedCustomizeMessageStep
      headerBreadcrumbs={getSourcingExternalHeaderBreadcrumbs({
        candidateBatchJobTitle:
          candidateBatch?.jobDescriptionParsed?.jobTitle ?? '',
        candidateBatchId: candidateBatch?.id ?? '',
        setStep
      })}
      applicationFormData={applicationFormData}
      candidateBatchAtsJobId={!!candidateBatch?.atsJobId}
      candidateBatchAtsJobPostingUrl={candidateBatch?.atsJobPostingUrl}
      editedOpeningMessage={editedOpeningMessage}
      jobInformationFormData={jobInformationFormData}
      defaultStartingTemplatedMessage={defaultStartingTemplatedMessage}
      isDefaultStartingTemplatedMessageLoading={
        isDefaultStartingTemplatedMessageLoading
      }
      selectedRowLength={selectedRows.length}
      customizeMessageFormData={customizeMessageFormData}
      onCustomizeMessageBack={handleCustomizeMessageBack}
      onCustomizeMessageNext={(data) =>
        onCustomizeMessageNext({
          // External sourcing we use the first candidate in the list as the first candidate
          firstCandidateInListId: selectedRows[0]?.id ?? '',
          customizeMessageFormData: data
        })
      }
      onCustomizeMessageInviteSubmit={(formData) =>
        onCustomizeMessageInviteSubmit({
          customizeMessageFormData: formData,
          payload: {
            // External sourcing we use sourced candidates ids
            type: 'external',
            sourcedCandidatesIds: selectedRows.map((row) => row.id)
          }
        })
      }
      channelType={channelFormData?.channel ?? Channels.Email}
    />
  );
};
